import Properties from "./Properties";
import Metadata from "./Metadata";
import New from "./New";
import Variants from "./Variants";
import Wrapper from "./Wrapper";

export default {
  Properties,
  Metadata,
  New,
  Variants,
  Wrapper
};
